import React, { useContext } from 'react';
import { truncateText } from 'src/views/utils/truncate-text';
import {
  ArticleSettings,
} from 'src/infrastructure/gatsby/types/article-settings';
import { PageContext } from 'views/templates/context';
import DefaultTheme from './theme';

export const ArticleCardTheme = DefaultTheme;

type Props = {
  article: ArticleSettings;
  theme?: typeof DefaultTheme;
}

const ArticleCard: React.FC<Props> = ({
  article,
  theme = DefaultTheme,
}) => {
  const pageContext = useContext(PageContext);

  return (
    <theme.Main href={`/${ pageContext.pageSettings.slug }/${ article.slug }/`}>
      {article.image?.localFile?.childImageSharp?.fluid ? (
        <theme.CardImage
          fluid={article.image?.localFile?.childImageSharp?.fluid}
          alt={article.image?.alternativeText || ''}
          objectFit="cover"
          objectPosition="center top"
        />
      ) : null}
      <theme.Text>
        <theme.Date>
          {article.publishDate}
        </theme.Date>
        <theme.Title>
          {truncateText(article.title, 74, false)}
        </theme.Title>
        <theme.Description>
          {truncateText(
            article.excerpt || article.content,
            130,
            false,
          )}
        </theme.Description>
      </theme.Text>
    </theme.Main>
  );
};

export default ArticleCard;
